import {renderPayPalCardFields, removePayPalCardFields} from "./checkout";

(function ($) {

	let payment_method_id, shipping_method_id
	let paypal_card_fields_rendered = false
	let last_evaluated_email = null
	let email_timer = null

	function isValidEmail(email) {
		return typeof email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
	}

	function handleEmailChange() {
		const currentEmail = $('form#checkout__form input[type="email"]').val()?.trim() || ''
		if (currentEmail === last_evaluated_email) {
			return
		}
		if (isValidEmail(currentEmail) || (currentEmail.length === 0 && last_evaluated_email !== null)) {
			last_evaluated_email = currentEmail
			update_cart('form#checkout__form')
		}
	}

	// Update cart

	async function update_cart(formSelector) {
		let data = $(formSelector).serializeArray()
		data = Object.fromEntries( data.map( item => [ item.name, item.value ] ) )

		if (typeof data.email !== 'undefined') {
			last_evaluated_email = data.email.trim()
		}

		payment_method_id = data.payment_method_id

		// Force new card fields render if payment or shipping method changed
		if (paypal_card_fields_rendered && (payment_method_id !== 'paypal_card' || shipping_method_id !== data.shipping_method_id)){
			paypal_card_fields_rendered = false
		}

		shipping_method_id = data.shipping_method_id

		gp_ajax({
			url: ghostpress_params.ajax_url + "&action=checkout_update_shipping_payment",
			type: "post",
			dataType: "json",
			data,
			show_loading: true,
			success: function (response) {
				// Clear pickup point address when shipping method is changed
				if (response.data.shipping_method_changed) {
					const pickup_point_fields = [
						'pickup_point_id',
						'pickup_point_type',
						'company_name',
						'address_line_1',
						'city',
						'zip'
					]

					pickup_point_fields.forEach(name => {
						$(`input[name=shipping_${name}]`).val('')
					})
				}
			}
		})
			.done(async function () {
				// Re-render PayPal card fields if card payment is selected
				if (payment_method_id === 'paypal_card' && !paypal_card_fields_rendered) {
					await renderPayPalCardFields()
					paypal_card_fields_rendered = true
				}
			})
	}

	// Render card fields on page load if PayPal card is selected
	$(document).ready(async function () {
		const paypal_card_input = $('input[type=radio][name=payment_method_id][value=paypal_card]')
		if (paypal_card_input.is(':checked') && !paypal_card_fields_rendered) {
			await renderPayPalCardFields()
			paypal_card_fields_rendered = true
		}
		const initialEmail = $('form#checkout__form input[type="email"]').val()?.trim()
		if (initialEmail) {
			last_evaluated_email = initialEmail
		}
	})

	// Init again fields from AJAX fragments
	$(document).gp_ready(function () {
		// Shipping / payment method & country change handler
		$('form#checkout__form select[name=shipping_country], form#checkout__form input[name=shipping_method_id], form#checkout__form input[name=payment_method_id]').off("change").on("change", function (){
			return update_cart.call(this, 'form#checkout__form')
		})

		// Email change handler for live blacklist updates
		$('form#checkout__form input[type="email"]').off('input.payment_email').on('input.payment_email', function () {
			clearTimeout(email_timer)
			const email = $(this).val()?.trim() || ''
			if (isValidEmail(email) && email !== last_evaluated_email) {
				email_timer = setTimeout(() => {
					handleEmailChange()
				}, 500)
			}
		})

		$('form#checkout__form input[type="email"]').off('change.payment_email blur.payment_email').on('change.payment_email blur.payment_email', function () {
			clearTimeout(email_timer)
			handleEmailChange()
		})

		// Shipping store change handler
		$('form#checkout-store-pickup input[name=shipping_method_id]').off("change").on("change", function() {
			$(document).trigger('close_modal')
			return update_cart.call(this, 'form#checkout-store-pickup')
		})
	})

})(jQuery);